import React from "react"
import { Button, DialogActions } from "@mui/material";
import { ct } from "../../../../constant-Utils";

const PModalFooter = (props) => {
    return (
        <>
            <DialogActions
                className='w-100 d-flex justify-content-between'
                sx={{
                    p: 3,
                    pt: 0
                }}
            >
                {
                    props?.hideSubmit ? null :
                        <Button
                            onClick={() => props.submit()}
                            variant="contained"
                            className='payment-theme-btn-success'
                        >
                            Submit
                        </Button>
                }

                {
                    props?.hideCancel ? null :
                        <Button
                            onClick={() => props.cancel(false)}
                            variant="outlined"
                            className='payment-theme-btn-cancel'
                        >{ct("Translate.buttonTitle.cancelSmall")}</Button>
                }
            </DialogActions>
        </>)
}

export default PModalFooter;